import { TFunction } from 'i18next';
import { AiBudgetBlockedReasonEnum } from 'graphql-common';
import { AiErrorAction } from 'components/AiAssistant/utils/getAiErrorAction';

// Copy for a live `aiBudgetStatus.blockedReason`, shown wherever an AI control
// had to be taken away — the composer's replacement notice, an autofill
// popover, the import form's AI enhancements. Deliberately the same two
// messages the matching failure codes carry (budget_exhausted /
// budget_not_configured, see getAiErrorText): the user hitting the block up
// front and the user who raced past it are being told the same thing.
const TEXT_KEY_BY_REASON: Record<AiBudgetBlockedReasonEnum, string> = {
  [AiBudgetBlockedReasonEnum.BudgetExhausted]: 'ai-unavailable-no-credits',
  [AiBudgetBlockedReasonEnum.BudgetNotConfigured]:
    'ai-error-budget-not-configured',
};

export function getAiBudgetBlockedText(
  t: TFunction<'translation', undefined>,
  reason?: AiBudgetBlockedReasonEnum | null,
): string | null {
  return reason ? t(TEXT_KEY_BY_REASON[reason]) : null;
}

// What the user can do about it. An exhausted budget is a plan decision they
// can act on; an unconfigured one needs an administrator, and the copy already
// says so — a button leading nowhere is worse than none.
const ACTION_BY_REASON: Record<AiBudgetBlockedReasonEnum, AiErrorAction> = {
  [AiBudgetBlockedReasonEnum.BudgetExhausted]: AiErrorAction.UpgradePlan,
  [AiBudgetBlockedReasonEnum.BudgetNotConfigured]: AiErrorAction.None,
};

export function getAiBudgetBlockedAction(
  reason?: AiBudgetBlockedReasonEnum | null,
): AiErrorAction {
  return reason ? ACTION_BY_REASON[reason] : AiErrorAction.None;
}
